import type { ReactNode } from 'react';

import { Circle, CircleText, Content, HeadingText, Wrapper } from './Step.parts';

export type NumberedStepVariant = 'plain' | 'card';

export type StepProps = {
	number?: number;
	heading?: ReactNode;
	variant?: NumberedStepVariant;
	children: ReactNode;
};

export function Step(props: StepProps) {
	return (
		<Wrapper variant={props.variant}>
			<Circle variant={props.variant}>
				<CircleText variant={props.variant}>{props.number}</CircleText>
			</Circle>
			<Content>
				{props.heading && <HeadingText>{props.heading}</HeadingText>}
				{props.children}
			</Content>
		</Wrapper>
	);
}
